/**
 * @description 本地缓存封装
 * @created 2023/07/20 11:29:05
 */

// 验证是否为 json
function isJSON(jsonString) {
  try {
    JSON.parse(jsonString)
    return true
  } catch (error) {
    return false
  }
}

export function get(key) {
  const value = localStorage.getItem(key)
  if (value && isJSON(value)) {
    return JSON.parse(value).data ? JSON.parse(value).data : value
  }
  return value
}

export function set(key, value) {
  localStorage.setItem(key, JSON.stringify({
    type: Object.prototype.toString.call(value).slice(8, -1),
    data: value
  }))
}

export function remove(key) {
  localStorage.removeItem(key)
}
